import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { signOut } from "aws-amplify/auth";
import { getConfigName } from "@helpers/funciones";
import { COTIZADORES_LEGACY_PATHS, CotizadorV2Type, cotizadoresV2PorTipo } from "@helpers/cotizadoresV2Config";

interface CotizadoresV2Props {
  type?: CotizadorV2Type;
}

export const CotizadoresV2 = ({ type = "credito_simple" }: CotizadoresV2Props) => {
  const { search } = useLocation();
  const configName = getConfigName(window.location.href);
  const Component = cotizadoresV2PorTipo[type]?.[configName];

  useEffect(() => {
    if (!Component) return;

    const logout = async () => {
      localStorage.clear();
      await signOut();
    };

    logout();
  }, [Component]);

  if (!Component) {
    return <Navigate to={`${COTIZADORES_LEGACY_PATHS[type]}${search}`} replace />;
  }

  return <Component />;
};
